import { render, staticRenderFns } from "./payuotDetailOrderlist.vue?vue&type=template&id=ca720ed8&scoped=true"
import script from "./payuotDetailOrderlist.vue?vue&type=script&lang=js"
export * from "./payuotDetailOrderlist.vue?vue&type=script&lang=js"
import style0 from "./payuotDetailOrderlist.vue?vue&type=style&index=0&id=ca720ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca720ed8",
  null
  
)

export default component.exports